import { render, staticRenderFns } from "./LotList.vue?vue&type=template&id=5008ff5d&scoped=true"
import script from "./LotList.vue?vue&type=script&lang=js"
export * from "./LotList.vue?vue&type=script&lang=js"
import style0 from "./LotList.vue?vue&type=style&index=0&id=5008ff5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008ff5d",
  null
  
)

export default component.exports